import { frontendURL } from '../../../../helper/URLHelper';
import SettingsWrapper from '../SettingsWrapper.vue';
import AiKnowledge from './Index.vue';

export default {
  routes: [
    {
      path: frontendURL('accounts/:accountId/settings/ai-knowledge'),
      component: SettingsWrapper,
      children: [
        {
          path: '',
          redirect: to => {
            return { name: 'ai_knowledge_list', params: to.params };
          },
        },
        {
          path: 'list',
          name: 'ai_knowledge_list',
          component: AiKnowledge,
          meta: {
            permissions: ['administrator'],
          },
        },
      ],
    },
  ],
};
